import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

import HomePage from "@/views/pages/HomePage.vue";

import Login from "@/views/pages/Auth/Login.vue";
import Register from "@/views/pages/Auth/Register.vue";

import SendResetPassword from "@/views/pages/Auth/Password/SendReset.vue";
import ResetPassword from "@/views/pages/Auth/Password/Reset.vue";

import SettingsPage from "@/views/pages/Gallery/SettingsPage.vue";
import PhotosPage from "@/views/pages/Gallery/PhotosPage.vue";
import DesignPage from "@/views/pages/Gallery/DesignPage.vue";
import FavoritesPage from "@/views/pages/Gallery/FavoritesPage.vue";

import UserSettingsPage from "@/views/pages/User/SettingsPage.vue";
import UserSubscriptionPage from "@/views/pages/User/SubscriptionPage.vue";
import UserSubscriptionCheckoutPage from "@/views/pages/User/Subscription/CheckoutPage.vue";
import UserSubscriptionThankYouPage from "@/views/pages/User/Subscription/ThankYouPage.vue";
import UserProfilePage from "@/views/pages/User/ProfilePage.vue";

import VerificationVerify from "@/views/pages/User/Verification/Verify.vue";
import PageNotFound from "@/views/pages/PageNotFound.vue";

const router = createRouter({
    routes: [
        { path: '/', component: HomePage, meta: {requiresAuth: true}, name: "home" },

        { path: '/verification/verify', component: VerificationVerify, meta: {requiresAuth: true}, name: "verification.verify" },
        { path: '/verification/verify/:id/:hash', component: VerificationVerify, meta: {requiresAuth: true}, name: "verification.confirm" },

        { path: '/email/verify', component: VerificationVerify, meta: {requiresAuth: true}, name: "email.verify" },
        { path: '/email/verify/:id/:hash', component: VerificationVerify, meta: {requiresAuth: true}, name: "email.confirm" },

        { path: '/galleries/:gallery/settings', component: SettingsPage, meta: {requiresAuth: true}, name: "galleries.settings" },
        { path: '/galleries/:gallery/photos', component: PhotosPage, meta: {requiresAuth: true}, name: "galleries.photos" },
        { path: '/galleries/:gallery/design', component: DesignPage, meta: {requiresAuth: true}, name: "galleries.design" },

        // { path: '/galleries/:gallery/folders/create', component: FolderCreatePage, meta: {requiresAuth: true}, name: "galleries.folders.create"},
        // { path: '/galleries/:gallery/folders/:folder', component: FolderEditPage, meta: {requiresAuth: true}, name: "galleries.folders.edit"},

        { path: '/galleries/:gallery/favorites', component: FavoritesPage, meta: {requiresAuth: true}, name: "galleries.favorites" },

        { path: '/settings', component: UserSettingsPage, meta: {requiresAuth: true}, name: 'user.settings' },
        // { path: '/settings/security', component: UserSettingsSecurityPage, meta: {requiresAuth: true}, name: 'user.settings.security' },

        { path: '/profile', component: UserProfilePage, meta: {requiresAuth: true}, name: 'user.profile' },

        { path: '/cards', redirect: (to) => ({ path: '/subscription', hash: to.hash }), name: "user.cards" },
        { path: '/subscription', component: UserSubscriptionPage, meta: {requiresAuth: true}, name: 'user.subscription' },
        { path: '/checkout/:key', component: UserSubscriptionCheckoutPage, meta: {requiresAuth: true}, name: 'user.subscription.checkout' },
        { path: '/thank-you', component: UserSubscriptionThankYouPage, meta: {requiresAuth: true}, name: 'user.subscription.thank_you' },

        { path: '/login', component: Login, meta: {requiresGuest: true} },
        { path: '/register', component: Register, meta: {requiresGuest: true} },

        { path: '/login/social/:provider/callback', component: Login, meta: {requiresGuest: true}, name: "login.social.callback" },

        { path: '/password/reset', component: SendResetPassword, meta: {requiresGuest: true} },
        { path: '/password/reset/:token', component: ResetPassword, meta: {requiresGuest: true} },

        { path: "/:pathMatch(.*)*", component: PageNotFound, name: "404" }
    ],
    history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
    // if (to.matched.some(record => record.meta.inDevelopmentFlag)) {
    //     if(!store.getters.features[to.meta.inDevelopmentFlag]) {
    //         next('/dev');
    //         return;
    //     }
    // }

    const isLoggedIn = store.getters["user/isLoggedIn"];

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (isLoggedIn) {
            next();
            return;
        }

        next('/login');
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
        if (! isLoggedIn) {
            next();
            return;
        }
        next('/');
    } else {
        next();
    }
})


export default router;